module.exports = __webpack_public_path__ + "static/media/signup-main.39beea50.png";